import React, { Dispatch, FC, SetStateAction } from 'react'
import './packetAddOn.scss'
import { plusIcon } from 'assets'
import { CounterButton } from 'components/counterButton/CounterButton'
import { Card } from 'components/card/Card'
import { SelectedPacket } from 'components/enrollForm/enrollFormTypes'
import { colors } from 'styles/colors'
import { usePacketSelection } from '../../hooks/usePacketSelection'
import { constants } from 'helpers/constants'
import { numberFormatter } from 'helpers/numberFormatter'

type PacketAddOnProps = {
    productPacket: SelectedPacket
    quantity: number
    packetSelectionHandler: Dispatch<SetStateAction<SelectedPacket[]>>
}

export const PacketAddOn: FC<PacketAddOnProps> = ({
    productPacket,
    quantity,
    packetSelectionHandler
}) => {
    const {
        counter,
        setCounter,
        showCounterButton,
        selectedPacket,
        packetRef,
        price,
        sizeDisplay,
        size,
        handlePacketSelection
    } = usePacketSelection({
        productPacket,
        quantity,
        packetSelectionHandler
    })

    let selectedClassName =
        selectedPacket || counter > 0 ? 'card-product--selected' : ''

    if (selectedClassName !== '') {
        selectedClassName += '--add-on'
    }

    const unitPrice = Number(price) || 0
    const displayAmount = counter > 0 ? unitPrice * counter : unitPrice
    const hidePrice = Boolean(productPacket.hidePrice)

    const renderCountOrPlusIcon = () => {
        return counter > 0 ? (
            <div className="packet-addon-product-units">{counter}</div>
        ) : (
            <div
                onClick={handlePacketSelection}
                className="packet-addon--add-icon"
            >
                {plusIcon({
                    color: colors.white,
                    width: '16',
                    height: '16'
                })}
            </div>
        )
    }

    return (
        <div className="packet-addon--parent" ref={packetRef}>
            <Card
                onClick={handlePacketSelection}
                className="card--product-parent"
            >
                <div
                    data-testid={`packet-addon-${size}`}
                    className={`card-product ${selectedClassName}`}
                    aria-label={'card-packet-add-on'}
                >
                    {productPacket.image_url && (
                        <img
                            src={productPacket.image_url}
                            alt={productPacket.name}
                            className="card-product-picture"
                            onError={(
                                event: React.SyntheticEvent<
                                    HTMLImageElement,
                                    Event
                                >
                            ) =>
                                ((
                                    event.target as HTMLImageElement
                                ).style.display = 'none')
                            }
                        ></img>
                    )}
                    <div
                        className="card-product-name"
                        aria-label={'add-on-details'}
                    >
                        {productPacket.name}
                        <br />
                        {sizeDisplay}
                    </div>
                    {showCounterButton ? (
                        <div
                            className="packet-addon--counter"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <CounterButton
                                count={counter}
                                onCountChange={setCounter}
                                maxCount={constants.MAX_ORDER_OF_PACKAGE}
                            />
                        </div>
                    ) : (
                        renderCountOrPlusIcon()
                    )}
                </div>
            </Card>
            {price && (
                <div
                    className="packet-addon-product-price"
                    data-testid={`packet-addon-price-${size}`}
                >
                    {numberFormatter(displayAmount, 'CFA', hidePrice)}
                </div>
            )}
        </div>
    )
}
